module.exports = __webpack_public_path__ + "img/tauranga-large.6e55a458.png";